import { render, staticRenderFns } from "./MarkdownRenderer.vue?vue&type=template&id=16a10cc4&lang=pug"
import script from "./MarkdownRenderer.vue?vue&type=script&lang=ts"
export * from "./MarkdownRenderer.vue?vue&type=script&lang=ts"
import style0 from "./MarkdownRenderer.vue?vue&type=style&index=0&id=16a10cc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports